'use client';

import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/app/components/theme-provider';
import { useEffect, useState } from 'react';

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Only show the toggle after component is mounted to avoid hydration mismatch
  useEffect(() => setMounted(true), []);

  if (!mounted) return null;

  return (
    <button
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      className='p-2 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors'
      aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`}
    >
      {theme === 'dark' ? (
        <Sun className='h-5 w-5 text-secondarycolor' />
      ) : (
        <Moon className='h-5 w-5 text-primarycolor' />
      )}
      <span className='sr-only'>Toggle theme</span>
    </button>
  );
}
